import { DraperPlayerProps } from '../types'
import DraperPlayer from '../DraperPlayer'

export function canTakeLock(props: DraperPlayerProps): boolean {
    if (props.playerIsActive) {
        return props.videoContext.activeActivePlayer === null
    } else {
        return props.videoContext.activePassivePlayer === null

    }
}

export function hasLock(props: DraperPlayerProps, draperPlayer: DraperPlayer): boolean {
    if (props.playerIsActive) {
        return props.videoContext.activeActivePlayer === draperPlayer
    } else {
        return props.videoContext.activePassivePlayer === draperPlayer && props.videoContext.activeActivePlayer === null
    }
}

export function takeLock(props: DraperPlayerProps, draperPlayer: DraperPlayer) {
    if (props.playerIsActive) {
        props.videoContext.updateContext({ ...props.videoContext, activeActivePlayer: draperPlayer })
    } else {
        props.videoContext.updateContext({ ...props.videoContext, activePassivePlayer: draperPlayer })
    }
}

export function releaseLock(props: DraperPlayerProps, draperPlayer: DraperPlayer) {
    if (props.playerIsActive && props.videoContext.activeActivePlayer === draperPlayer) {
        props.videoContext.updateContext({ ...props.videoContext, activeActivePlayer: null })
    } else if (props.videoContext.activePassivePlayer === draperPlayer) {
        props.videoContext.updateContext({ ...props.videoContext, activePassivePlayer: null })
    }
}